import { render } from "./Forum-select.vue?vue&type=template&id=71c040e8&scoped=true&lang=pug"
import script from "./Forum-select.vue?vue&type=script&setup=true&lang=js"
export * from "./Forum-select.vue?vue&type=script&setup=true&lang=js"

import "./Forum-select.vue?vue&type=style&index=0&id=71c040e8&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c040e8"]])

export default __exports__